import React from 'react'
import { MOCK_MESSAGES } from 'tests/stubs/messageApi'
import { MessageFragment } from './messageFragment'

export const MessageFragmentSkeleton = ({ currentUser }: { currentUser: IUser }) => {
  const fakeMessage = MOCK_MESSAGES[0]
  fakeMessage.content = Array(4).fill('random big line of text to simulate long content on message\n').join('')
  return <MessageFragment message={fakeMessage} currentUser={currentUser} isLoading={true} />
}
